import { useQuery } from "@tanstack/react-query";
import { REFRESH_INTERVAL } from "../models/constants";
import { getCurrentDelay } from "../repositories/MillSetupRepository";

export const useCurrentDelay = () => {
	return useQuery({
		queryKey: ["millSetup", "currentDelay"],
		queryFn: ({ signal }) => getCurrentDelay(signal),
		refetchInterval: REFRESH_INTERVAL,
		staleTime: REFRESH_INTERVAL - 1000,
		retry: false,
		refetchOnWindowFocus: false,
	});
};
